import { Injectable } from "@angular/core";
import { lastValueFrom, Observable, tap } from "rxjs";
import { BrokerService } from "src/app/sse/broker.service";
import { SseEvents } from "src/app/sse/sse-events";
import { consoleGrouped } from "src/app/support/console";

@Injectable()
export class OptimisticUiService {
  invoke<T>({
    observableFn,
    dataFn,
    payloadFn,
    event
  }: {
    observableFn: () => Observable<T>;
    dataFn: () => object;
    payloadFn: () => object;
    event: SseEvents;
  }): Observable<T> {
    return observableFn().pipe(
      tap({
        complete: () => {
          const data = dataFn();
          const payload = payloadFn();

          const msg = {
            event,
            isOptmistic: true,
            data: JSON.stringify({
              ...data,
              ...payload
            })
          };

          consoleGrouped(`[OPT-SSE] onmessage "${event}"`, () => ({
            ...msg,
            data: payload
          }));

          BrokerService.instance?.publish(msg);
        }
      })
    );
  }

  invokeAsync<T>({
    observableFn,
    dataFn,
    payloadFn,
    event
  }: {
    observableFn: () => Observable<T>;
    dataFn: () => object;
    payloadFn: () => object;
    event: SseEvents;
  }): Promise<T> {
    return lastValueFrom(
      this.invoke({
        dataFn,
        event,
        observableFn,
        payloadFn
      })
    );
  }
}
